import React from "react";
import { toast } from "sonner";

export default function Contact() {
  const submit = (e) => {
    e.preventDefault();
    toast.success("Thanks — we'll be in touch shortly.");
    e.target.reset();
  };
  return (
    <div className="cm-container py-14">
      <div className="max-w-2xl">
        <div className="cm-eyebrow mb-2">Contact</div>
        <h1 className="cm-h2">Talk to us.</h1>
        <p className="cm-body mt-3">Have a question? Our team will get back within one working day. For medical emergencies, call 999.</p>
        <form className="cm-card mt-8 space-y-4" onSubmit={submit} data-testid="contact-form">
          <div><label className="cm-label">Your name</label><input className="cm-input" required data-testid="contact-name"/></div>
          <div><label className="cm-label">Email</label><input className="cm-input" type="email" required data-testid="contact-email"/></div>
          <div><label className="cm-label">Message</label><textarea className="cm-input min-h-[120px]" required data-testid="contact-message"/></div>
          <button className="cm-btn-primary w-full" data-testid="contact-submit">Send message</button>
        </form>
      </div>
    </div>
  );
}
